import { useState, useEffect, useCallback } from 'react';
import { router, type Route } from '../utils/router';

export const useRouter = () => {
  const [currentRoute, setCurrentRoute] = useState<Route>(router.getCurrentRoute());
  const [params, setParams] = useState<Record<string, string>>(router.getParams());

  useEffect(() => {
    const updateRoute = () => {
      setCurrentRoute(router.getCurrentRoute());
      setParams(router.getParams());
    };
    
    return router.subscribe(updateRoute);
  }, []);

  const navigate = useCallback((route: Route, params?: Record<string, string>) => {
    router.navigate(route, params);
  }, []);

  return { currentRoute, params, navigate };
};


